import React, {PureComponent} from 'react';
import TranslatedText from '../../atoms/TranslatedText';

import './SportSpecificProgressivesSlide.css';

const OVERLAYS = {
    cycling: {
        labels: [
            'sport_specific_progressives.cycling.label1',
            'sport_specific_progressives.cycling.label2',
            'sport_specific_progressives.cycling.label3',
        ],
        0: {
            label: 'sport_specific_progressives.cycling.label1',
            img: require('./cycling/cycling-frame-1.png'),
        },
        1: {
            label: 'sport_specific_progressives.cycling.label2',
            img: require('./cycling/cycling-frame-2.png'),
        },
        2: {
            label: 'sport_specific_progressives.cycling.label3',
            img: require('./cycling/cycling-frame-3.png'),
        },
    },
    golf: {
        labels: [
            'sport_specific_progressives.golf.label1',
            'sport_specific_progressives.golf.label2',
            'sport_specific_progressives.golf.label3',
        ],
        0: {
            label: 'sport_specific_progressives.golf.label1',
            img: require('./golf/golf-frame-1.png'),
        },
        1: {
            label: 'sport_specific_progressives.golf.label2',
            img: require('./golf/golf-frame-2.png'),
        },
        2: {
            label: 'sport_specific_progressives.golf.label3',
            img: require('./golf/golf-frame-3.png'),
        },
    },
    angling: {
        labels: [
            'sport_specific_progressives.angling.label1',
            'sport_specific_progressives.angling.label2',
            'sport_specific_progressives.angling.label3',
        ],
        0: {
            label: 'sport_specific_progressives.angling.label1',
            img: require('./angling/angling-frame-1.png'),
        },
        1: {
            label: 'sport_specific_progressives.angling.label2',
            img: require('./angling/angling-frame-2.png'),
        },
        2: {
            label: 'sport_specific_progressives.angling.label3',
            img: require('./angling/angling-frame-3.png'),
        },
    },
};
let currentFrameStyle;
let labelStatus = 'active';
let labelBottomStatus;
let labelSight;

export default class SportSpecificProgressivesSlide extends PureComponent {
    render() {
        const {
            title,
            description,
            bg,
            glasses,
            type,
            changeGlasses,
            frame,
        } = this.props;

        const currentSport = OVERLAYS[type];

        const style = {backgroundImage: `url(${bg})`};

        // if user hasn't click anything
        if (frame !== null) {
            currentFrameStyle = {
                backgroundImage: `url(${currentSport[frame].img})`,
            };
            labelStatus = '';
            labelBottomStatus = 'active';
            labelSight = (
                <div className="SportSpecificProgressivesSlide-sight-label">
                    <TranslatedText tag="sport_specific_progressives.cycling.label_sight" />
                </div>
            );
        } else {
            currentFrameStyle = {
                backgroundImage: `url(${glasses})`,
            };
            labelStatus = 'active';
            labelBottomStatus = '';
            labelSight = '';
        }

        // labels showing on the lens before the user clicks
        const labels = currentSport.labels.map((sport, index) => (
            <div
                key={index}
                className={`SportSpecificProgressivesSlide-btn SportSpecificProgressivesSlide-btn--${index}`}
                onClick={() => changeGlasses(index)}>
                <div
                    className={`SportSpecificProgressivesSlide-label SportSpecificProgressivesSlide-label--${index}`}>
                    <TranslatedText tag={sport} />
                </div>
            </div>
        ));

        const labelUnderGlasses = currentSport.labels[frame];

        return (
            <article
                className={`SportSpecificProgressivesSlide SportSpecificProgressivesSlide--${type}`}
                style={style}>
                <div className="SportSpecificProgressivesSlide-top">
                    <h3 className="top-title">
                        <TranslatedText tag={title} />
                    </h3>
                    <div className="top-subtitle">
                        <TranslatedText tag={description} />
                    </div>
                </div>
                <div
                    className="SportSpecificProgressivesSlide-frame"
                    style={currentFrameStyle}>
                    <div
                        className={`SportSpecificProgressiveSlide-btns SportSpecificProgressiveSlide-btns--${labelStatus}`}>
                        {labels}
                    </div>
                    {labelSight}
                </div>
                <div
                    className={`SportSpecificProgressivesSlide-label-bottom ${labelBottomStatus}`}>
                    <TranslatedText tag={labelUnderGlasses} />
                </div>
            </article>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/sportSpecificProgressives/SportSpecificProgressivesSlide.js